import { Skeleton } from "@mui/material";

export const ProjectSkeleton = () => {
  return <Skeleton />;
};
